import { getLocalStorage as getStorage } from './storage';


export default function getYear() {
  return getStorage(['year']).year;
}
